import BasicButtonGroup from  './BasicButtonGroup'
import { SpaceAroundButtonGroup, SpaceBetweenButtonGroup } from  './EvenSpaceButtonGroup'
import TabButtonGroup from './TabButtonGroup'

const EvenSpaceButtonGroup = SpaceAroundButtonGroup;

export { BasicButtonGroup, EvenSpaceButtonGroup, SpaceAroundButtonGroup, SpaceBetweenButtonGroup, TabButtonGroup };